// extracted by mini-css-extract-plugin
export default {"menu":"MenuPropertiesGroupsList_menu__jvMBb","centered":"MenuPropertiesGroupsList_centered__giUBf","message":"MenuPropertiesGroupsList_message__-3EN4"};